import { type TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';

class LineFeedTagParser implements TagParser {
  tag = 'linefeed';

  parse() {
    return {
      html: '<br>',
      consumedLength: 0,
    };
  }
}

ParserRegistry.register(new LineFeedTagParser());
